import apiService from './api';
import {
  type PublicToken,
  type UpdateProfileEmailRequestData,
  type UpdateUserProfileRequestData,
  type UploadImageResponse,
  type UserProfileResponse,
  type VerifyProfileEmailRequestData,
} from '@/types';

class UserProfileService {
  getProfile = async () => {
    const response = await apiService.get<UserProfileResponse>('/admin/users/profile');

    return response.data;
  };

  getPublicToken = async () => {
    const response = await apiService.get<PublicToken>('/admin/users/public-token');

    return response.data;
  };

  updateProfile = async (data: UpdateUserProfileRequestData) => {
    try {
      const response = await apiService.put<UserProfileResponse>('/admin/users/profile', data);
      return response.data;
    } catch (e) {
      console.error('Error updating user profile:', e);
      throw e;
    }
  };

  uploadProfileImage = async (image: File) => {
    try {
      const response = await apiService.post<UploadImageResponse>(
        '/admin/users/profile/image',
        { image },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (e) {
      console.error('Error uploading profile image:', e);
      throw e;
    }
  };

  verifyProfileEmail = async (data: VerifyProfileEmailRequestData) => {
    const response = await apiService.post<UserProfileResponse>('/admin/users/profile/email/verify', data);

    return response.data;
  };

  resendProfileEmailVerification = async () => {
    await apiService.post('/admin/users/profile/email/resend', {});
  };

  updateProfileEmail = async (data: UpdateProfileEmailRequestData) => {
    await apiService.put<void>('/admin/users/profile/email', data);
  };
}

export default new UserProfileService();
